/* eslint-disable react/jsx-curly-newline */
/* eslint-disable import/no-duplicates */
import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import { useRouteMatch, useLocation, Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import {
  addDays,
  format,
  parseISO,
  startOfWeek,
  differenceInMinutes,
  endOfDay,
  isWithinInterval,
  differenceInDays,
  startOfDay,
  isSameDay,
  isSaturday,
  isMonday,
  isSunday,
} from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { Button, ButtonGroup, Row, Col, Container } from 'react-bootstrap';

import {
  FaCaretLeft,
  FaCaretRight,
  FaRegCalendar,
  FaRetweet,
  FaInfoCircle,
  FaRegCheckCircle,
  FaRegQuestionCircle,
  FaRegMoneyBillAlt,
  FaRegClock,
  FaRegThumbsUp,
  FaRegCalendarCheck,
  FaBan,
  FaDollarSign,
  FaIdCard,
  FaUndo,
  FaUser,
  FaSearch,
  FaFileMedicalAlt,
  FaRegThumbsDown,
  FaMedkit,
  FaRegEnvelope,
  FaClock,
  FaFileExcel,
  FaHandshake,
  FaNotesMedical,
} from 'react-icons/fa';

import { useToast } from '../../hooks/toast';
import { useAuth } from '../../hooks/auth';
import { useClinica } from '../../hooks/clinica';
import api from '../../services/api';
import {
  CONFIRMACAO_AGENDA,
  statusAgendamento,
  STATUS_AGENDA,
} from '../../utils/funcoes';

import Agendamento from '../../components/Agendamento';
import OrcamentoProcedimento from '../../components/OrcamentoProcedimento';
import TrocarAgenda from '../../components/TrocarAgenda';
import Modal from '../../components/Modal';
import Input from '../../components/Input';
import Loading from '../../components/Loading';

import {
  FlexBetween,
  NomeAgenda,
  HeaderAgenda,
  Calendario,
  DiaCabecalho,
  Hora,
  DiasContainer,
  Marcacao,
  AgendamentoContainer,
  CalendarioAddContainer,
  ButtonAdd,
  ButtonAgendamentoDoDia,
} from './styles';
import getResponseErrors from '../../utils/getResponseErrors';

export interface IConfigAgendaBasica {
  ConCodigo: number;
  ConPerfil: string;
  ConPerfilCodigo: string;
  ConNome: string;
  ConTempoPadrao: number;
  ConObs: string;
  ConClinica: number;
  ConSemanal: number;
  ConIntegracao: number;
  ConTratamento: boolean;
}
interface IConfigAgenda extends IConfigAgendaBasica {
  horarios?: [
    {
      HorCodigo: number;
      HorConCodigo: number;
      HorDia: number;
      HorIntervaloIni: string;
      HorIntervaloFim: string;
      HorHoraIni: string;
      HorHoraFim: string;
    },
  ];
  horarioRecorrente?: {
    HorCodigo: number;
    HorConCodigo: number;
    HorDataIni: Date;
    HorDiasRecorre: number;
    HorIntervaloIni: string;
    HorIntervaloFim: string;
    HorHoraIni: string;
    HorHoraFim: string;
  };
  perfil: {
    PerCodigo: number;
    PerNome: string;
    PerTipo: number;
  }[];
}

interface IAgenda {
  configuracaoAgenda: IConfigAgenda;
  disponibilidade: [
    {
      data: Date;
      dataFormatada: string;
      temHorarioDisponivel: boolean;
      horarios: [
        {
          data: Date;
          hora: number;
          minuto: string;
          liberado: boolean;
          obs: string;
        },
      ];
    },
  ];
}

interface IAgendamento {
  AgeCodigo: number;
  AgeObs: string;
  AgeInicio: Date;
  AgeFim: Date;
  AgeStatus: number;
  AgeConfirmado: number;
  AgePlano: boolean;
  paciente: {
    PacCodigo: number;
    PacNome: string;
    PacNomeSocial: string;
  };
  top?: number;
  left?: string;
  width?: string;
  height?: string;
  status?: {
    id: number;
    nome: string;
    color: string;
    icon: string;
  };
}

interface IAgendamentoHoje {
  AgeCodigo: number;
  AgeInicio: Date;
  AgeFim: Date;
  AgeHoraFormatada: string;
  AgeStatus: number;
  AgeConfirmado: number;
  AgePlano: boolean;
  AgeConvCodigo: number;
  ConvNome: string;
  PacNome: string;
  PacNomeSocial: string;
  eRetorno: boolean;
  status?: {
    id: number;
    nome: string;
    color: string;
    icon: string;
  };
}
interface IAgendaParams {
  id: string;
  dia: string;
}

interface IIcons {
  [key: string]: JSX.Element;
}

const icons: IIcons = {
  ban: <FaBan size={15} />,
  question: <FaRegQuestionCircle size={15} />,
  check: <FaRegCheckCircle size={15} />,
  money: <FaRegMoneyBillAlt size={15} />,
  clock: <FaRegClock size={15} />,
  thumbs: <FaRegThumbsUp size={15} />,
  calendar: <FaRegCalendarCheck size={15} />,
  thumbsDown: <FaRegThumbsDown size={15} />,
};

const Agenda: React.FC = () => {
  const history = useHistory();
  const formRefData = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const { user } = useAuth();
  const { params } = useRouteMatch<IAgendaParams>();

  const { optionsClinica, imagensClinica } = useClinica();

  const NomeClinica = !imagensClinica.find(img => img.nome === 'saopaulo')
    ? 'Clinica Médica Dr Saúde'
    : 'Centro Médico Dr São Paulo';

  const [agendandoOutraClinica, setAgendandoOutraClinica] = useState('');
  const [loading, setLoading] = useState(false);
  const [showModalAgendas, setShowModalAgendas] = useState(false);
  const [showModalData, setShowModalData] = useState(false);
  const [showModalHorarios, setShowModalHorarios] = useState(false);

  const { id } = params;

  function useQuery(): URLSearchParams {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();

  const [idAgenda, setIdAgenda] = useState(() => {
    return id ? Number(id) : 50;
  });

  const [diasExibicao, setDiasExibicao] = useState(() => {
    return query.get('dias') && Number(query.get('dias')) === 7 ? 7 : 1;
  });

  const dataHoje = isSunday(new Date()) ? addDays(new Date(), 1) : new Date();

  const [diaSelecionado, setDiaSelecionado] = useState<Date>(() => {
    return query.get('data') && query.get('data')?.length === 10
      ? parseISO(`${query.get('data')} 03:00:00`)
      : dataHoje;
  });

  const [agenda, setAgenda] = useState<IAgenda>();
  const [agendamentos, setAgendamentos] = useState<IAgendamento[]>();
  const [agendamentosHoje, setAgendamentosHoje] = useState<
    IAgendamentoHoje[]
  >();
  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState<
    number | undefined
  >(undefined);

  const [showAgendando, setShowAgendando] = useState(false);
  const [showOrcamento, setShowOrcamento] = useState(false);
  const [agendamentoData, setAgendamentoData] = useState(diaSelecionado);

  const handleBuscaAgendamentosHoje = useCallback(async () => {
    setLoading(true);
    try {
      const data = diasExibicao === 1 ? diaSelecionado : new Date();
      const response = await api.get<IAgendamentoHoje[]>(
        `agendamentos/dehoje?ConCodigo=${idAgenda}&Data=${format(
          data,
          'yyyy-MM-dd',
        )}`,
      );
      setAgendamentosHoje(
        response.data.map(age => {
          return {
            ...age,
            ConvNome: age.AgeConvCodigo === 0 ? '' : age.ConvNome,
            AgeHoraFormatada: `${format(
              parseISO(age.AgeInicio.toString()),
              'HH:mm',
            )} - ${format(parseISO(age.AgeFim.toString()), 'HH:mm')}`,
            status: statusAgendamento.find(status =>
              age.AgeStatus === STATUS_AGENDA.AGENDADO
                ? status.id === (age.AgeConfirmado + 1 >= 2 ? 2 : 1)
                : status.id === age.AgeStatus,
            ),
          };
        }),
      );
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível buscar agendamento de hoje',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [idAgenda, diaSelecionado, diasExibicao, addToast]);

  const handleFormataAgendamentoAdicionado = useCallback(
    async (agendamentoFormatar: IAgendamento) => {
      if (!agenda) {
        return;
      }

      await handleBuscaAgendamentosHoje();

      const AgeInicio = parseISO(agendamentoFormatar.AgeInicio.toString());

      const horaInicialAgenda = parseISO(
        agenda.disponibilidade[0].horarios[0].data.toString(),
      );
      const inicioAgenda = startOfDay(horaInicialAgenda);
      const fimAgenda = endOfDay(addDays(horaInicialAgenda, 5));
      const agendamentoForaDataExibicao =
        diasExibicao === 1
          ? !isSameDay(inicioAgenda, AgeInicio)
          : !isWithinInterval(AgeInicio, {
              start: inicioAgenda,
              end: fimAgenda,
            });

      if (
        agendamentoFormatar.AgeStatus < STATUS_AGENDA.AGENDADO ||
        agendamentoForaDataExibicao
      ) {
        setAgendamentos(state => {
          return state?.filter(
            age => age.AgeCodigo !== agendamentoFormatar.AgeCodigo,
          );
        });
        return;
      }

      const tempoAtendimento = agenda.configuracaoAgenda.ConTempoPadrao;

      const width =
        diasExibicao === 1
          ? 'calc(100% - 47px)'
          : `calc(16% - ${47 / diasExibicao}px)`;

      const diaCalculo = differenceInDays(startOfDay(AgeInicio), inicioAgenda);

      const left =
        diasExibicao === 1 ? '47px' : `calc(${diaCalculo * 16}% + 47px)`;

      const dataSelecionada = addDays(horaInicialAgenda, diaCalculo);

      const diferencaMinutos = differenceInMinutes(AgeInicio, dataSelecionada);
      const top = (diferencaMinutos / tempoAtendimento) * 40 + 18;
      const diferencaMinutosAgendamento = differenceInMinutes(
        parseISO(agendamentoFormatar.AgeFim.toString()),
        AgeInicio,
      );

      const height =
        diferencaMinutosAgendamento === tempoAtendimento
          ? '39px'
          : `${(diferencaMinutosAgendamento / tempoAtendimento) * 39}px`;

      const agendamentoFormatado: IAgendamento = {
        ...agendamentoFormatar,
        status: statusAgendamento.find(status =>
          agendamentoFormatar.AgeStatus === STATUS_AGENDA.AGENDADO
            ? status.id === (agendamentoFormatar.AgeConfirmado + 1 >= 2 ? 2 : 1)
            : status.id === agendamentoFormatar.AgeStatus,
        ),
        top,
        left,
        height,
        width,
      };

      setAgendamentos(state => {
        const findAgendamento = state?.find(
          age => age.AgeCodigo === agendamentoFormatar.AgeCodigo,
        );

        if (findAgendamento && state) {
          const agendamentosOK = state.filter(
            age => age.AgeCodigo !== agendamentoFormatar.AgeCodigo,
          );
          const agendamentosCertos = agendamentosOK.concat([
            agendamentoFormatado,
          ]);
          return agendamentosCertos;
        }

        return state?.concat([agendamentoFormatado]);
      });
    },
    [diasExibicao, agenda, handleBuscaAgendamentosHoje],
  );

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IAgenda>(
          `agendas/disponibilidade?id=${idAgenda}&data=${format(
            diaSelecionado,
            'yyyy-MM-dd',
          )}&dias=${diasExibicao}`,
        );

        setAgenda(response.data);
        if (user.UsuClinica !== response.data.configuracaoAgenda.ConClinica)
          setAgendandoOutraClinica(
            `AGENDANDO NA ${
              optionsClinica.find(
                cli =>
                  cli.value ===
                  response.data.configuracaoAgenda.ConClinica.toString(),
              )?.label || 'VAZIO'
            }`,
          );

        const responseAgendamentos = await api.get<IAgendamento[]>(
          `agendamentos/agenda?AgeConfCodigo=${idAgenda}&AgeData=${format(
            diaSelecionado,
            'yyyy-MM-dd',
          )}&Dias=${diasExibicao}`,
        );
        // handleFormataAgendamentos(response.data);
        if (!response.data) {
          return;
        }
        const horaInicialAgenda = parseISO(
          response.data.disponibilidade[0].horarios[0].data.toString(),
        );
        const tempoAtendimento =
          response.data.configuracaoAgenda.ConTempoPadrao;

        let agendamentosFormatados: IAgendamento[] | undefined;
        const dias = diasExibicao === 1 ? 1 : 6;
        const width =
          diasExibicao === 1
            ? 'calc(100% - 47px)'
            : `calc(16% - ${47 / diasExibicao}px)`;

        for (let diaIndex = 0; diaIndex < dias; ) {
          const dataSelecionada = addDays(horaInicialAgenda, diaIndex);
          const inicioDia = startOfDay(dataSelecionada);
          const fimDia = endOfDay(dataSelecionada);

          const left =
            diasExibicao === 1 ? '47px' : `calc(${diaIndex * 16}% + 47px)`;
          const agendamentosSelecionadosDia = responseAgendamentos.data.filter(
            age =>
              isWithinInterval(parseISO(age.AgeInicio.toString()), {
                start: inicioDia,
                end: fimDia,
              }) && age.AgeStatus > STATUS_AGENDA.CANCELADO,
          );

          const teste = agendamentosSelecionadosDia.map(age => {
            const dataInicio = parseISO(age.AgeInicio.toString());
            const diferencaMinutos = differenceInMinutes(
              dataInicio,
              dataSelecionada,
            );
            const incrementoTop =
              (diferencaMinutos / tempoAtendimento) * 40 + 18;
            const diferencaMinutosAgendamento = differenceInMinutes(
              parseISO(age.AgeFim.toString()),
              dataInicio,
            );

            const height =
              diferencaMinutosAgendamento === tempoAtendimento
                ? '39px'
                : `${(diferencaMinutosAgendamento / tempoAtendimento) * 39}px`;

            return {
              ...age,
              status: statusAgendamento.find(status =>
                age.AgeStatus === STATUS_AGENDA.AGENDADO
                  ? status.id === (age.AgeConfirmado + 1 >= 2 ? 2 : 1)
                  : status.id === age.AgeStatus,
              ),
              top: incrementoTop,
              left,
              height,
              width,
            };
          });
          diaIndex += 1;

          if (agendamentosFormatados) {
            agendamentosFormatados = agendamentosFormatados.concat(teste);
          } else {
            agendamentosFormatados = teste;
          }
        }
        setAgendamentos(agendamentosFormatados);

        await handleBuscaAgendamentosHoje();
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar disponibilidade',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    if (idAgenda) {
      loadDados();
      history.replace(
        `/agenda/${idAgenda}?data=${format(
          diaSelecionado,
          'yyyy-MM-dd',
        )}&dias=${diasExibicao}`,
      );
    }
  }, [
    idAgenda,
    diaSelecionado,
    diasExibicao,
    optionsClinica,
    user.UsuClinica,
    addToast,
    handleBuscaAgendamentosHoje,
    history,
  ]);

  useEffect(() => {
    document.title = agenda?.configuracaoAgenda.ConNome
      ? `Agenda ${agenda?.configuracaoAgenda.ConNome}`
      : 'Agenda';
  }, [agenda?.configuracaoAgenda.ConNome]);

  // useEffect(() => {
  //   async function loadDados(): Promise<void> {
  //     setLoading(true);
  //     try {
  //       const response = await api.get<IAgendamento[]>(
  //         `agendamentos/agenda?AgeConfCodigo=${idAgenda}&AgeData=${format(
  //           diaSelecionado,
  //           'yyyy-MM-dd',
  //         )}&Dias=${diasExibicao}`,
  //       );
  //       // handleFormataAgendamentos(response.data);
  //       if (!agenda) {
  //         return;
  //       }
  //       const horaInicialAgenda = parseISO(
  //         agenda.disponibilidade[0].horarios[0].data.toString(),
  //       );
  //       const tempoAtendimento = agenda.configuracaoAgenda.ConTempoPadrao;

  //       let agendamentosFormatados: IAgendamento[] | undefined;
  //       const dias = diasExibicao === 1 ? 1 : 6;
  //       const width =
  //         diasExibicao === 1
  //           ? 'calc(100% - 47px)'
  //           : `calc(16% - ${47 / diasExibicao}px)`;

  //       for (let diaIndex = 0; diaIndex < dias; ) {
  //         const dataSelecionada = addDays(horaInicialAgenda, diaIndex);
  //         const inicioDia = startOfDay(dataSelecionada);
  //         const fimDia = endOfDay(dataSelecionada);

  //         const left =
  //           diasExibicao === 1 ? '47px' : `calc(${diaIndex * 16}% + 47px)`;
  //         const agendamentosSelecionadosDia = response.data.filter(
  //           age =>
  //             isWithinInterval(parseISO(age.AgeInicio.toString()), {
  //               start: inicioDia,
  //               end: fimDia,
  //             }) && age.AgeStatus > STATUS_AGENDA.CANCELADO,
  //         );

  //         const teste = agendamentosSelecionadosDia.map(age => {
  //           const dataInicio = parseISO(age.AgeInicio.toString());
  //           const diferencaMinutos = differenceInMinutes(
  //             dataInicio,
  //             dataSelecionada,
  //           );
  //           const incrementoTop =
  //             (diferencaMinutos / tempoAtendimento) * 40 + 18;
  //           const diferencaMinutosAgendamento = differenceInMinutes(
  //             parseISO(age.AgeFim.toString()),
  //             dataInicio,
  //           );

  //           const height =
  //             diferencaMinutosAgendamento === tempoAtendimento
  //               ? '39px'
  //               : `${(diferencaMinutosAgendamento / tempoAtendimento) * 39}px`;

  //           return {
  //             ...age,
  //             status: statusAgendamento.find(
  //               status => status.id === age.AgeStatus,
  //             ),
  //             top: incrementoTop,
  //             left,
  //             height,
  //             width,
  //           };
  //         });
  //         diaIndex += 1;

  //         if (agendamentosFormatados) {
  //           agendamentosFormatados = agendamentosFormatados.concat(teste);
  //         } else {
  //           agendamentosFormatados = teste;
  //         }
  //       }
  //       setAgendamentos(agendamentosFormatados);

  //       await handleBuscaAgendamentosHoje();
  //     } catch (error) {
  //       const mensagemErro = getResponseErrors(error);
  //       addToast({
  //         title: 'Não foi possível carregar dados da agenda',
  //         type: 'error',
  //         description: mensagemErro,
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  //   if (idAgenda) loadDados();
  // }, [
  //   idAgenda,
  //   agenda,
  //   diaSelecionado,
  //   diasExibicao,
  //   addToast,
  //   handleBuscaAgendamentosHoje,
  // ]);

  const horarioAgenda = useMemo(() => {
    if (!agenda?.configuracaoAgenda.horarios) {
      return [];
    }
    const diasSemana: { [key: string]: string } = {
      dia2: 'seg',
      dia3: 'ter',
      dia4: 'qua',
      dia5: 'qui',
      dia6: 'sex',
      dia7: 'sab',
    };
    const horariosFormatados = agenda?.configuracaoAgenda.horarios.map(
      horario => {
        return {
          HorDia: diasSemana[`dia${horario.HorDia}`],
          HorHoraIni: horario.HorHoraIni,
          HorHoraFim: horario.HorHoraFim,
          HorIntervaloIni: horario.HorIntervaloIni,
          HorIntervaloFim: horario.HorIntervaloFim,
        };
      },
    );
    return horariosFormatados;
  }, [agenda?.configuracaoAgenda]);

  const handleSelecionaAgendamento = useCallback((AgeCodigo: number) => {
    setAgendamentoSelecionado(AgeCodigo);
    setShowAgendando(true);
  }, []);

  const handleSelecionaHorario = useCallback(
    (idAgendaSelecionado: number, data: Date) => {
      setAgendamentoData(data);
      setShowAgendando(true);
    },
    [],
  );

  const handleFecharAgendamentoAgenda = useCallback(
    (agendamentoListagem: IAgendamento | undefined) => {
      if (agendamentoListagem) {
        handleFormataAgendamentoAdicionado(agendamentoListagem);
      }
      setAgendamentoSelecionado(undefined);
      setShowAgendando(false);
    },
    [handleFormataAgendamentoAdicionado],
  );

  const dataFormatada = useMemo(() => {
    const data =
      diasExibicao === 1
        ? diaSelecionado
        : startOfWeek(diaSelecionado, { weekStartsOn: 1 });
    return diasExibicao === 1
      ? format(data, "EEEE', 'dd 'de' MMMM 'de' yyyy", { locale: ptBR })
      : `${format(data, 'dd/MM')} - ${format(
          addDays(data, 5),
          'dd/MM',
        )} de ${data.getFullYear()}`;
  }, [diaSelecionado, diasExibicao]);

  const handleTrocaAgenda = useCallback((idAgendaTroca: number) => {
    setShowModalAgendas(false);
    setIdAgenda(idAgendaTroca);
  }, []);

  const handleTrocaData = useCallback(formData => {
    setShowModalData(false);
    setDiaSelecionado(parseISO(formData.dataTroca));
  }, []);

  const handleNextDay = useCallback(() => {
    if (diasExibicao === 1) {
      setDiaSelecionado(state =>
        isSaturday(state) ? addDays(state, 2) : addDays(state, 1),
      );
      return;
    }
    setDiaSelecionado(state =>
      addDays(startOfWeek(state, { weekStartsOn: 1 }), 7),
    );
  }, [diasExibicao]);

  const handlePreviousDay = useCallback(() => {
    if (diasExibicao === 1) {
      setDiaSelecionado(state =>
        isMonday(state) ? addDays(state, -2) : addDays(state, -1),
      );
      return;
    }
    setDiaSelecionado(state =>
      addDays(startOfWeek(state, { weekStartsOn: 1 }), -6),
    );
  }, [diasExibicao]);

  const handleToday = useCallback(() => {
    setDiaSelecionado(new Date());
  }, []);

  const handleChangeView = useCallback((dias: number) => {
    setDiasExibicao(dias);
  }, []);

  const totalAtendimentosHoje = useMemo(() => {
    let totalGeral = 0;
    let totalParticular = 0;
    let totalConvenio = 0;
    let totalCartao = 0;
    let totalRetorno = 0;
    let totalConfirmado = 0;
    let convenios;

    if (agendamentosHoje) {
      totalGeral = agendamentosHoje.filter(
        age => age.AgeStatus > STATUS_AGENDA.CANCELADO,
      ).length;
      totalParticular = agendamentosHoje.filter(
        age =>
          age.AgePlano === false &&
          age.AgeStatus > STATUS_AGENDA.CANCELADO &&
          age.AgeConvCodigo === 0,
      ).length;
      totalConvenio = agendamentosHoje.filter(
        age =>
          age.AgePlano === false &&
          age.AgeStatus > STATUS_AGENDA.CANCELADO &&
          age.AgeConvCodigo > 0,
      ).length;
      totalCartao = totalGeral - totalParticular - totalConvenio;
      totalRetorno = agendamentosHoje.filter(
        age => age.eRetorno === true && age.AgeStatus > STATUS_AGENDA.CANCELADO,
      ).length;
      totalConfirmado = agendamentosHoje.filter(
        age =>
          age.AgeConfirmado > CONFIRMACAO_AGENDA.AGUARDANDO_CONFIRMACAO &&
          age.AgeStatus >= STATUS_AGENDA.AGENDADO,
      ).length;

      const dados = agendamentosHoje.filter(it => it.AgeConvCodigo > 0);
      if (dados.length > 0)
        convenios = dados.reduce((acc: Record<string, number>, item) => {
          acc[item.ConvNome] = (acc[item.ConvNome] || 0) + 1;
          return acc;
        }, {});
    }

    return {
      totalGeral,
      totalParticular,
      totalConvenio,
      convenios,
      totalCartao,
      totalRetorno,
      totalConfirmado,
    };
  }, [agendamentosHoje]);

  return (
    <Container fluid className="pl-0">
      {showModalData && (
        <Modal
          show={showModalData}
          titulo="Escolha uma data"
          handleFecharModal={() => setShowModalData(false)}
          large={false}
        >
          <Form
            ref={formRefData}
            initialData={{ dataTroca: format(diaSelecionado, 'yyyy-MM-dd') }}
            onSubmit={handleTrocaData}
          >
            <Input
              name="dataTroca"
              type="date"
              placeholder="Selecione uma data"
              containerStyle={{ maxWidth: '200px' }}
            />
            <div className="d-flex justify-content-end">
              <Button type="submit" className="mt-2" size="sm">
                Selecionar
              </Button>
            </div>
          </Form>
        </Modal>
      )}
      {showModalAgendas && (
        <Modal
          show={showModalAgendas}
          titulo="Selecionar outra Agenda"
          handleFecharModal={() => setShowModalAgendas(false)}
        >
          <TrocarAgenda handleSelecionaAgenda={handleTrocaAgenda} />
        </Modal>
      )}
      {showAgendando && agenda && (
        <Modal
          show={showAgendando}
          titulo={`Agendamento ${
            agendamentoSelecionado ? `#${agendamentoSelecionado}` : ''
          } - ${agenda.configuracaoAgenda.ConNome}`}
          handleFecharModal={
            () => {
              setAgendamentoSelecionado(undefined);
              setShowAgendando(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <Agendamento
            agendaId={idAgenda}
            perfilId={
              agendamentoSelecionado
                ? undefined
                : agenda.configuracaoAgenda.ConPerfilCodigo
            }
            data={agendamentoSelecionado ? undefined : agendamentoData}
            AgeCodigo={agendamentoSelecionado}
            handleFecharAgendamento={agendamentoListagem =>
              handleFecharAgendamentoAgenda(agendamentoListagem)
            }
          />
        </Modal>
      )}
      {showModalHorarios && (
        <Modal
          show={showModalHorarios}
          titulo="Configurações da Agenda"
          handleFecharModal={() => setShowModalHorarios(false)}
          large={false}
        >
          <table className="table table-sm table-bordered table-striped">
            <thead>
              <tr>
                <th>Dia</th>
                <th>Hora Inicial</th>
                <th>Intervalo</th>
                <th>Hora Final</th>
              </tr>
            </thead>
            <tbody>
              {horarioAgenda &&
                horarioAgenda.map(horario => (
                  <tr key={horario.HorDia}>
                    <td>{horario.HorDia}</td>
                    <td>{horario.HorHoraIni}</td>
                    <td>{`${horario.HorIntervaloIni} às ${horario.HorIntervaloIni}`}</td>
                    <td>{horario.HorHoraFim}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          {agenda && agenda.configuracaoAgenda.ConObs.length > 0 && (
            <div className="border rounded p-3">
              <h6>
                <b>Observações:</b>
              </h6>
              {agenda.configuracaoAgenda.ConObs.split('\n').map(obs => (
                <p>{obs}</p>
              ))}
            </div>
          )}
        </Modal>
      )}

      {showOrcamento && (
        <Modal
          show={showOrcamento}
          titulo="Valor Particular X Associado"
          handleFecharModal={
            () => {
              setShowOrcamento(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <OrcamentoProcedimento exibeBusca />
        </Modal>
      )}

      {loading && <Loading backgroundBlack={false} />}

      <Row noGutters>
        <Col sm={0} md={3} lg={2} className="pr-2">
          <div className="bg-white border h-100">
            <h5 className="p-2 text-secondary">Pacientes de Hoje</h5>

            {agendamentosHoje && agendamentosHoje.length > 0 ? (
              <>
                <div className="d-flex justify-content-between text-muted mb-1">
                  <span>{`Total:${totalAtendimentosHoje.totalGeral}`}</span>
                  <div>
                    <span className="pr-1">
                      <FaUser title="Particular" />{' '}
                      {totalAtendimentosHoje.totalParticular}
                    </span>
                    <span className="pr-1">
                      <FaHandshake title="Convênio" />{' '}
                      {totalAtendimentosHoje.totalConvenio}
                    </span>
                    <span className="pr-1">
                      <FaIdCard title="Cartão Saúde" />{' '}
                      {totalAtendimentosHoje.totalCartao} |
                    </span>
                    <span className="pr-1">
                      <FaUndo title="Retorno" />{' '}
                      {totalAtendimentosHoje.totalRetorno}
                    </span>
                    <span className="pr-1">
                      <FaRegCheckCircle title="Confirmados" />{' '}
                      {totalAtendimentosHoje.totalConfirmado}
                    </span>
                  </div>
                </div>
                {totalAtendimentosHoje && totalAtendimentosHoje.convenios && (
                  <div className="text-muted mb-1">
                    {Object.keys(totalAtendimentosHoje.convenios).map(ob => (
                      <div>
                        <span>
                          <small>
                            {`${ob}: ${
                              totalAtendimentosHoje.convenios
                                ? totalAtendimentosHoje.convenios[ob]
                                : '0'
                            }`}
                          </small>
                        </span>
                      </div>
                    ))}
                  </div>
                )}
                {agendamentosHoje.map(age => (
                  <ButtonAgendamentoDoDia
                    type="button"
                    key={`dehoje-${age.AgeCodigo.toString()}`}
                    data-id={age.AgeCodigo}
                    onClick={() => handleSelecionaAgendamento(age.AgeCodigo)}
                  >
                    <span style={{ width: '97%' }}>
                      <span
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <b style={{ color: age.status?.color }}>
                          {age.AgeHoraFormatada}
                        </b>
                        {age.AgeConvCodigo > 0 && (
                          <span style={{ color: 'red' }}>
                            <small>{age.ConvNome}</small>
                          </span>
                        )}
                      </span>
                      {age.PacNomeSocial?.trim() !== '' ? (
                        <small>{`Nome Social: ${age.PacNomeSocial}`}</small>
                      ) : (
                        <small>{age.PacNome}</small>
                      )}
                    </span>
                    <span>
                      {icons[age.status ? age.status.icon : 'question']}
                      {age.AgeStatus === STATUS_AGENDA.PAGAMENTO_ANTECIPADO &&
                      age.AgeConfirmado ===
                        CONFIRMACAO_AGENDA.AGUARDANDO_CONFIRMACAO
                        ? icons.question
                        : ''}
                      {age.AgeStatus === STATUS_AGENDA.PAGAMENTO_ANTECIPADO &&
                      age.AgeConfirmado === CONFIRMACAO_AGENDA.NAO_VAI
                        ? icons.thumbsDown
                        : ''}
                      {age.AgePlano === true && <FaIdCard />}
                      {age.eRetorno === true && <FaUndo />}
                    </span>
                  </ButtonAgendamentoDoDia>
                ))}
              </>
            ) : (
              <h6 className="text-info">Sem agendamentos</h6>
            )}
          </div>
        </Col>
        <Col sm={12} md={9} lg={10}>
          <div className="bg-white border rounded p-2 mt-2">
            <FlexBetween>
              <NomeAgenda className="mb-0">
                {agenda?.configuracaoAgenda.ConNome}
              </NomeAgenda>
              {agendandoOutraClinica.length === 0 ? (
                <h6 className="mb-0">{NomeClinica}</h6>
              ) : (
                <h6 className="mb-0 text-danger">{agendandoOutraClinica}</h6>
              )}
            </FlexBetween>

            <HeaderAgenda>
              <div>
                <ButtonGroup size="sm">
                  <Button
                    type="button"
                    variant="outline-secondary"
                    onClick={handlePreviousDay}
                  >
                    <FaCaretLeft />
                  </Button>
                  <Button
                    type="button"
                    variant="outline-secondary"
                    onClick={handleToday}
                  >
                    Hoje
                  </Button>
                  <Button
                    type="button"
                    variant="outline-secondary"
                    onClick={handleNextDay}
                  >
                    <FaCaretRight />
                  </Button>
                </ButtonGroup>

                <Button
                  type="button"
                  variant="outline-secondary"
                  size="sm"
                  style={{ marginLeft: 4 }}
                  onClick={() => setShowModalData(true)}
                >
                  <FaRegCalendar size={16} />
                </Button>

                <Button
                  type="button"
                  variant="outline-secondary"
                  size="sm"
                  style={{ marginLeft: 4 }}
                  onClick={() => history.push('/agendabusca')}
                >
                  <FaSearch size={16} />
                </Button>

                <Button
                  type="button"
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setShowModalAgendas(true)}
                >
                  <FaRetweet size={16} />
                  Trocar Agenda
                </Button>
              </div>
              <div>
                <strong>{dataFormatada}</strong>
              </div>
              <div>
                <Link
                  to={`/procedimentosagendadosexport?agenda=${id}&data=${format(
                    diaSelecionado,
                    'yyyy-MM-dd',
                  )}&dataFim=${format(diaSelecionado, 'yyyy-MM-dd')}`}
                  className="btn btn-sm btn-outline-secondary mr-1"
                  title="Exportar Procedimentos Agendados"
                  target="_blank"
                >
                  <FaFileExcel size={16} />
                </Link>
                {agenda?.configuracaoAgenda.ConTratamento === true && (
                  <Link
                    to="/tratamentos"
                    className="btn btn-sm btn-outline-secondary mr-1"
                    title="Tratamentos"
                  >
                    <FaMedkit size={16} />
                  </Link>
                )}
                <Link
                  to={`/listaesperaatendimento?agenda=${id}`}
                  className="btn btn-sm btn-outline-secondary mr-1"
                  title="Lista de Atendimento"
                  target="_blank"
                >
                  <FaClock size={16} />
                </Link>
                <Link
                  to="/agendaenvioconfirmacao"
                  className="btn btn-sm btn-outline-secondary mr-1"
                  title="Envio de confirmação"
                  target="_blank"
                >
                  <FaRegEnvelope size={16} />
                </Link>
                <Link
                  to="/pedidoexamesbusca"
                  className="btn btn-sm btn-outline-secondary mr-1"
                  title="Pedido de Exames"
                  target="_blank"
                >
                  <FaFileMedicalAlt size={16} />
                </Link>
                <Link
                  to="/pedidoencaminhamentobusca"
                  className="btn btn-sm btn-outline-secondary mr-1"
                  title="Pedido de Encaminhamento"
                  target="_blank"
                >
                  <FaNotesMedical size={16} />
                </Link>

                <Link
                  to={`/agendabusca?status=${STATUS_AGENDA.FALTA}`}
                  className="btn btn-sm btn-outline-secondary mr-1"
                >
                  Faltas
                </Link>

                <Button
                  type="button"
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => handleChangeView(1)}
                >
                  Diario
                </Button>
                <Button
                  type="button"
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => handleChangeView(7)}
                >
                  Semanal
                </Button>
                <Button
                  type="button"
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setShowOrcamento(true)}
                >
                  <FaDollarSign size={16} />
                </Button>
                <Button
                  type="button"
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setShowModalHorarios(true)}
                >
                  <FaInfoCircle size={16} />
                </Button>
              </div>
            </HeaderAgenda>

            <Calendario>
              <Hora>
                <DiaCabecalho
                  temHorarioDisponivel
                  style={{ borderRightWidth: '0' }}
                />
                {agenda?.disponibilidade[0].horarios.map(linha => (
                  <div key={`${linha.hora}:${linha.minuto}`}>
                    {linha.hora}
                    <span>{linha.minuto}</span>
                  </div>
                ))}
              </Hora>
              <DiasContainer>
                {agendamentos &&
                  agendamentos.map(agendamento => (
                    <AgendamentoContainer
                      onClick={() =>
                        // eslint-disable-next-line prettier/prettier
                        handleSelecionaAgendamento(agendamento.AgeCodigo)
                      }
                      key={agendamento.AgeCodigo.toString()}
                      data-id={agendamento.AgeCodigo}
                      style={{
                        top: agendamento.top,
                        left: agendamento.left,
                        width: agendamento.width,
                        height: agendamento.height,
                        backgroundColor:
                          agendamento.AgeStatus ===
                            STATUS_AGENDA.PAGAMENTO_ANTECIPADO &&
                          agendamento.AgeConfirmado ===
                            CONFIRMACAO_AGENDA.NAO_VAI
                            ? '#dc3545'
                            : agendamento.status?.color,
                      }}
                      title={
                        agendamento.AgeObs
                          ? ` Observação: ${agendamento.AgeObs}`
                          : ''
                      }
                    >
                      {
                        icons[
                          agendamento.status
                            ? agendamento.status.icon
                            : 'question'
                        ]
                      }
                      {agendamento.AgeStatus ===
                        STATUS_AGENDA.PAGAMENTO_ANTECIPADO &&
                      agendamento.AgeConfirmado < CONFIRMACAO_AGENDA.NAO_VAI
                        ? icons[
                            agendamento.AgeConfirmado ===
                            CONFIRMACAO_AGENDA.AGUARDANDO_CONFIRMACAO
                              ? 'question'
                              : 'check'
                          ]
                        : ''}
                      {agendamento.AgeStatus ===
                        STATUS_AGENDA.PAGAMENTO_ANTECIPADO &&
                      agendamento.AgeConfirmado === CONFIRMACAO_AGENDA.NAO_VAI
                        ? icons.thumbsDown
                        : ''}
                      {agendamento.paciente.PacNomeSocial?.trim() !== ''
                        ? `Nome Social: ${agendamento.paciente.PacNomeSocial}`
                        : agendamento.paciente.PacNome}
                      {agendamento.AgeObs
                        ? ` Observação: ${agendamento.AgeObs}`
                        : ''}
                    </AgendamentoContainer>
                  ))}

                {agenda?.disponibilidade.map(dia => (
                  <Marcacao key={dia.dataFormatada}>
                    <DiaCabecalho
                      temHorarioDisponivel={dia.temHorarioDisponivel}
                    >
                      {dia.dataFormatada}
                    </DiaCabecalho>
                    {dia.horarios.map(linha => (
                      <CalendarioAddContainer
                        key={`${linha.hora}:${linha.minuto}`}
                      >
                        {linha.liberado ? (
                          <ButtonAdd
                            onClick={
                              () =>
                                // eslint-disable-next-line prettier/prettier
                                handleSelecionaHorario(idAgenda, linha.data)
                              // eslint-disable-next-line react/jsx-curly-newline
                            }
                          >
                            +
                          </ButtonAdd>
                        ) : (
                          <span>{linha.obs}</span>
                        )}
                      </CalendarioAddContainer>
                    ))}
                  </Marcacao>
                ))}
              </DiasContainer>
            </Calendario>
            {agenda && agenda.configuracaoAgenda.ConObs.length > 0 && (
              <div className="border rounded p-2 mx-2 mt-2">
                <h6>
                  <b>Observações:</b>
                </h6>
                {agenda.configuracaoAgenda.ConObs.split('\n').map(obs => (
                  <p>{obs}</p>
                ))}
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Agenda;
